import React, {Component, useState,Fragment} from 'react';
import Page, { PageWithTransitions } from'components/Page';
import InfiniteScroll from 'components/InfiniteScroll';
import { rootPath, mealPlanSetupBase, startPath, mealPlanSignupBase, 
     generateNewWeekBaseFor, emailPaywallMatches, setupWeeklyPlanPath, homePath, generateNewWeekPathFor, generateNewWeekMatch, switchForGenerateMatch, clientMealPlanSettingsMatch, fullModalPathFor, modalPathFor, mealPlanPath, pdfSetupDonePath } from 'config/paths';
import FlowForm, { FlowNav, FlowChooseGoal, FlowPageContent, FlowQuestionContainer, FlowQuestion, AutoAdvanceButton, NextButton, autoAdvanceSetValue } from 'components/FlowForm';
import { ItemSelectCard } from 'components/Card';
import { formikHandlerCreator } from 'lib/utilities';
import { User, MacroParams, MealType } from 'lib/classes';
import Button, { BottomButtons } from 'components/Button';
import { RCButtonWithErrors, CheckButtons, SelectButton, InputWithErrors, formikInputProps, arrayToggleCreator, SmallButtonSelect, WeekdayButtonSelect, TagButtons } from 'components/Form';
import { userRecordSelector, mealPlanFlowSelector, allergyTagsSelector, recommendedCalsSelector, initialRecipeOptionsSelector, trainerRecordSelector, showMpExitButton, msCategoryRecordSelector } from 'redux/selectors';
import { initMacros, advanceMealPlanSetup, resetInitialRecipeOptions, loadInitialRecipeOptions, getRecipeOptionsCatPage, startMealPlan, clearInitialSignup, switchClient, setInitialRecipesFilter, finishMealPlanSetup } from 'redux/actions';
import { connect } from 'react-redux';
import { useTranslation, withTranslation } from 'react-i18next';
import { Redirect } from "components/Routing";
import loadingContainer, { Loader, LoadingContainerParent } from 'components/LoadingHOC';
import moment from 'moment';
import * as _ from 'lib/utilities';
import classnames from 'classnames';
import { NumberInput } from 'components/TextInput';
import { UserMacroFields } from 'partials/CustomMacroFields';
import { WhiteBackgroundIcon } from 'components/Icon';
import { IconTip } from 'components/Tooltipped';
import { ExclusionTags, ExtraExclusions, validateSelectedMeals, validateCustomMacros } from 'partials/UserFields';
import Connector from 'partials/WebsiteConnector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Toast from 'components/Toast';
import * as transitions from 'assets/transitions';
import { SwitchFinished } from 'partials/ClientSwitcher';
import { mealPlanSlideOutPaths } from 'partials/MainLayout';
import { HideOnExit, RedirectContext } from 'components/RouteTransitionMap';
import { paywallPathFor, resolvedHomePath } from 'redux/helpers';
import { DailyNutritionProfile } from 'lib/daily-nutrition-profile';
import { SectionTab, SectionTabs } from 'components/BottomNav';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import { exportCurrentPDFSuffix } from 'partials/ExportPDFModal';
import { SimpleContentModal } from 'components/Modal';
import { SlightEmphasisIconNote } from 'components/Typography';
import { MacroWarning } from 'partials/MealAndRecipeSearch';
import { MealSearchCategory } from 'lib/meal-search';

const mealPlanSetupTransitionMap = {
    rules: [
        [[generateNewWeekMatch,switchForGenerateMatch],transitions.none],
        [[...mealPlanSlideOutPaths,clientMealPlanSettingsMatch,rootPath,startPath],transitions.slideOut],
        [[...emailPaywallMatches,pdfSetupDonePath],transitions.slideOver]
    ]
};

const validateForm = (user,t,page,values) => {
    if(page === 1) {
        if(_.isBlank(values.dietType)) {
            return { dietType: t('Required') }
        }
    } else if(page === 2) {
        let errs = {};
        if(_.isBlank(values.budget)) {
            errs.budget = t('Required');
        }
        if(_.isBlank(values.complexityPreference)) {
            errs.complexityPreference = t('Required');
        }
        if(_.isBlank(values.weeklyVariety)) {
            errs.weeklyVariety = t('Required');
        }
        return errs;
    } else if (page === 4) {
        return validateSelectedMeals(t)(values);
    } else if (page === 5) {
        if(!user.macrosInitialized()) {
            return { macros: 'macros must be initialized'}
        }
    } else if (page === 6) {
        return validateCustomMacros(t,user)(values);
    } else if (page === 7) {
        if(_.isBlank(values.mealPlanWeekday)) {
            return { mealPlanWeekday: t('Required') };
        }
    }
    return {}
}

const getNextPage = user => (page,values) => {
    let newPage = page+1;
    if(newPage === 6 && !_.get(values,'dailyNutritionProfiles.0.overrideCalories')) {
        newPage += 1;
    } else if(newPage === 8 && !user.showRecipePickStep()) {
        newPage += 1;
    }
    return newPage;
}

const valueFilter = values => values;

const FinishSetupRedirector = ({ user }) => (<Redirect to={user.isPdfClient() ? pdfSetupDonePath : mealPlanPath} />)

const FinishSetupLoader = ({ finishSetup, user, flowProps }) => {
    const { values } = flowProps;
    const submitValues = getSubmitValues(user,values);

    return (
        <Loader 
            type="padded"
            load={finishSetup.bind(null,submitValues)}
            preloaded={() => false}
            successComponent={FinishSetupRedirector}
            user={user}
        />
    )
}

class StartMealPlanSuccess extends React.Component {

    componentDidMount() {
        const { toExport, history, user, forNewWeek, clientId, location: { pathname }, responseData: { clientMpQuotaHit } } = this.props;
        if(clientMpQuotaHit) {
            const path = modalPathFor(mealPlanQuotaModalSuffix,pathname);
            setTimeout(() => history.push(path),30);
        } else {
            const basePath = user.afterMealPlanSetupPath(forNewWeek,clientId);
            if(toExport) {
                setTimeout(() => history.push(fullModalPathFor(exportCurrentPDFSuffix,basePath)),30);
            }
        }
    }

    render() {
        const { user, forNewWeek, clientId, responseData: { clientMpQuotaHit } } = this.props;

        if(clientMpQuotaHit) { 
            return '';
        }

        return (
            <Redirect to={user.afterMealPlanSetupPath(forNewWeek,clientId)} />
        )
    }
}

StartMealPlanSuccess = withRouter(StartMealPlanSuccess)

const StartMealPlanButtons = ({ user, load, setToExport, forNewWeek, clientId, t }) => {
    const pdfTrainerFlow = user.isPdfClient() && !_.isBlank(clientId);
    const pdfClientSetup = user.isPdfClient() && _.isBlank(clientId);

    const finalLoad = (toExport) => {
        setToExport(toExport);
        return load();
    }

    return (<React.Fragment>
        <Button color="primary" rounded onClick={() => finalLoad(false)} className="btn-wide" id="next-btn">
            <FontAwesomeIcon icon={pdfClientSetup ? "check" : "random"} />
            <span>{pdfClientSetup ? t('Done') : (forNewWeek ? t('Generate') : t("Start Plan"))}</span>
        </Button>
        {pdfTrainerFlow && (<Button color="primary" rounded outlined onClick={() => finalLoad(true)} className="btn-wide shadow ml5" id="export-btn">
            <FontAwesomeIcon icon={['far','file-export']} />
            <span>{t('Export PDF')}</span>
        </Button>)}
    </React.Fragment>)

}

const StartMealPlanButtonsWrapper = ({ user, t, forNewWeek, startMealPlan, initialRecipeIds }) => {
    const [toExport,setToExport] = useState(false);

    return (
        <MealPlanStandaloneContext.Consumer>
            {clientId => (
                <Loader 
                    defaultComponent={StartMealPlanButtons}
                    successComponent={StartMealPlanSuccess}
                    clientId={clientId}
                    toExport={toExport}
                    setToExport={setToExport}
                    type="loaderOnly"
                    skipAutoLoad
                    preloaded={() => false}
                    user={user}
                    forNewWeek={forNewWeek}
                    t={t}
                    load={startMealPlan.bind(null,initialRecipeIds,forNewWeek ? user.mealPlanStartDateFor(forNewWeek) : null,forNewWeek)}

                />
            )}
        </MealPlanStandaloneContext.Consumer>
        
    )
}

const recipeClickHandlerCreator = (category,dnpId,recipeId,initialRecipeIds,setInitialRecipeIds,setShowLimitFlash) => () => {
    const curDnp = initialRecipeIds[dnpId] || {};
    const currentIds = curDnp[category] || [];
    let newIds;
    arrayToggleCreator(currentIds,newVals => (newIds = newVals))(recipeId);
    setInitialRecipeIds({ ...initialRecipeIds, [dnpId]: { ...curDnp, [category]: newIds } });
    setShowLimitFlash(false);
}

const getMaxRecs = recipeOptions => {
    if(_.isBlank(recipeOptions)) {
        return 3;
    }

    const dnpVals = Object.values(recipeOptions);
    let maxRecs;
    if(dnpVals.length <= 1) {
        maxRecs = 3;
    } else if(dnpVals.length === 2) {
        maxRecs = 2;
    } else {
        maxRecs = 1;
    }

    return maxRecs;
}

let AddlFilters = ({ categories, allergyTags, user, mealTypeCategory, curFilter, setCurFilter, t }) => {
    const filteredCats = user.filteredMealSearchCats(categories,allergyTags,mealTypeCategory);
    const tags = MealSearchCategory.tagsCol(filteredCats, t, false);

    return (
        <div className="responsive-scrolling-wrapper">
            <TagButtons 
                col={[ { text: <Fragment><FontAwesomeIcon icon="heart" />{t('Favorites')}</Fragment>, value: 'favorites' }, { text: <Fragment><FontAwesomeIcon icon={['far','history']} />{t('Recent')}</Fragment>, value: 'recent' }, ...tags ]}
                name="mealSearchCategoryId"
                setFieldTouched={() => {}}
                setFieldValue={(name,value) => setCurFilter(value)}
                values={{ mealSearchCategoryId: curFilter }}
                buttonProps={ { className: 'ma2 btn-no-shadow' } }
                btnId={val => `filter-${mealTypeCategory}-${val}-btn`}
                single
                allowBlank
            />
        </div>
    )
}

const mapStateToFilterProps = (state) => ({
    categories: msCategoryRecordSelector(state),
    allergyTags: allergyTagsSelector(state),
    user: userRecordSelector(state)
})

AddlFilters = connect(mapStateToFilterProps)(AddlFilters)

const PossibleRecipesCat = ({ getRecipeOptionsCatPage, category, vals, initialRecipeIds, setInitialRecipeIds, setInitialRecipesFilter, dnpId, setShowLimitFlash, maxRecs, t }) => {
    const [showAddlFilters,setShowAddlFilters] = useState(!_.isBlank(vals.mealSearchCategoryId));
    const finalSetCurFilter = val => {
        setInitialRecipesFilter({ dnpId, category, filter: val });
        getRecipeOptionsCatPage(_.parseObjForForm({ category, dnpId, initialExclusions: [], seed: vals.seed, mealSearchCategoryId: val, pageExcluded: [] }),1);
    }

    const hideAddlFilters = () => {
        setShowAddlFilters(false);
        finalSetCurFilter(null);
    }

    const selIds = initialRecipeIds[dnpId] && initialRecipeIds[dnpId][category] && _.compact(initialRecipeIds[dnpId][category]);


    return (
        <div key={category} className="text-left" >
            <div className="signup-subheading-container ml10">
                <h4 className="thin-font-weight mb0">
                    <div className="valign-wrapper">
                        <div>{t(_.capitalize(category))}</div>
                        {selIds && selIds.length > 0 && (
                            <div className="inline-notificon ml10 primary bigger">
                                {selIds.length}
                            </div>
                        )}
                        <Button id={`filter-${category}-btn`} noShadow outlined color={showAddlFilters ? "grey" : "primary"} variant={"icon-only"} className={classnames("ml10", { 'no-border': showAddlFilters })} onClick={showAddlFilters ? hideAddlFilters : (() => setShowAddlFilters(true))}>
                            <FontAwesomeIcon icon={showAddlFilters ? 'times' : ['far','filter']}></FontAwesomeIcon>
                        </Button>
                    </div>
                </h4>
                {showAddlFilters && (<AddlFilters mealTypeCategory={category} curFilter={vals.mealSearchCategoryId} setCurFilter={finalSetCurFilter} t={t} />)}
            </div>
            <InfiniteScroll 
                key={vals.mealSearchCategoryId || 'default'}
                load={getRecipeOptionsCatPage.bind(null,_.parseObjForForm({ category, dnpId, initialExclusions: vals.initialExclusions, pageExcluded: vals.pageExcluded, seed: vals.seed, mealSearchCategoryId: vals.mealSearchCategoryId }))} 
                initialPage={1}
                loadedPage={Math.ceil(vals.recipes.length/10)} 
                fullyLoaded={vals.finished} 
                className={classnames("fatter-hz-scroll",{"horizontal-scrolling-wrapper": vals.recipes.length > 0 })}
                id={`${category}-recipe-options`}
                horizontal
                render={({ maxIndex }) => {
                    if(vals.recipes.length === 0) {
                        return(
                            <div className="text-center mt20 ml10 mr10">
                                <SlightEmphasisIconNote text={t("no rec options for filter")} />
                            </div>
                        )
                    }

                    return (
                        vals.recipes.map((recipe,index) => {
                            const irids = initialRecipeIds[dnpId];
                            const isActive = irids && irids[category] && irids[category].includes(recipe.id);
                            const numIrids = (!irids || !irids[category]) ? 0 : _.compact(irids[category]).length;
                            const allowAction = isActive || numIrids < maxRecs;
                            const meetsMacros = vals.meetsMacros[index];

                            if(index < maxIndex) {
                                return (
                                    <ItemSelectCard 
                                        key={recipe.id}
                                        onClick={allowAction ? recipeClickHandlerCreator(category,dnpId,recipe.id,initialRecipeIds,setInitialRecipeIds,setShowLimitFlash) : () => setShowLimitFlash(true)} 
                                        active={isActive}
                                    >
                                        {isActive && <WhiteBackgroundIcon containerClassName="upper-right-icon primary-text" icon="check-circle" size="2x" />}
                                        <img src={recipe.imageUrl('thumb')} className="signup-recipe-card-img" alt="" />
                                        <div className="signup-recipe-card-title">{recipe.name}</div>
                                        {!meetsMacros && (<MacroWarning msg={t("initial rec macro warn")} />)}
                                    </ItemSelectCard>
                                )
                            } else {
                                return '';
                            }

                        })
                    )
                }}
            />
        </div>
    )

}

const PossibleRecipes = ({ recipeOptions, t, getRecipeOptionsCatPage, setInitialRecipesFilter, startMealPlan, user, forNewWeek }) => {
    const [initialRecipeIds,setInitialRecipeIds] = useState({});
    const [showLimitFlash,setShowLimitFlash] = useState(false);
    const history = useHistory();


    if(!recipeOptions) {
        return '';
    }

    const useProFlash = !user.allowInitialRecipePick();
    const dnpVals = Object.values(recipeOptions);
    const maxRecs = useProFlash ? 0 : getMaxRecs(recipeOptions);

    const limitFlash = (<Toast 
        message={(<span className="lh1"><FontAwesomeIcon icon="info-circle" className="info-color" /> {maxRecs > 1 ? t("Please pick X or fewer recipes per meal type", { count: maxRecs }) : t('pick 1 recipe or less')}</span>)} 
        collapseContent={t("recipe pick limit tip")} 
        completeCallback={() => setShowLimitFlash(false)} 
        moreText={t('More')}
        dismissText={t('Ok')}
        displayLength={10000}
    />);

    const proFlash = (<Toast 
        message={(<span className="lh1"><FontAwesomeIcon icon="info-circle" className="info-color" /> {t('Upgrade to pro to select specific recipes')}</span>)} 
        completeCallback={() => setShowLimitFlash(false)} 
        dismissText={t('Upgrade')}
        okCallback={() => history.push(paywallPathFor('upgrade',user))}
        displayLength={10000}
    />)

    return (
        <div className="pb100 possible-recs-cont">
            {showLimitFlash && !useProFlash && limitFlash}
            {showLimitFlash && useProFlash && proFlash}
            <SectionTabs activeTab={0} hideIfOne white noBorder render={({ activeTab }) => {
                const { id: dnpId, name, ...options } = dnpVals[activeTab];
                return (
                    <React.Fragment>
                        {MealType.sortedCats(options).map(([category,vals]) => {
                            
                            return (
                                <PossibleRecipesCat
                                    getRecipeOptionsCatPage={getRecipeOptionsCatPage}
                                    key={`${dnpId}-${category}`}
                                    category={category}
                                    vals={vals}
                                    initialRecipeIds={initialRecipeIds}
                                    setInitialRecipeIds={setInitialRecipeIds}
                                    setInitialRecipesFilter={setInitialRecipesFilter}
                                    dnpId={dnpId}
                                    setShowLimitFlash={setShowLimitFlash}
                                    maxRecs={maxRecs}
                                    t={t}
                                />
                            )
                        })}
                    </React.Fragment>
                )
            }}>
                {dnpVals.map((dnp,index) => (<SectionTab key={dnp.id}>{dnp.name}</SectionTab>))}
            </SectionTabs>
            <BottomButtons>
                <StartMealPlanButtonsWrapper 
                    user={user}
                    t={t}
                    startMealPlan={startMealPlan}
                    forNewWeek={forNewWeek}
                    initialRecipeIds={initialRecipeIds}
                />
            </BottomButtons>
        </div>
    )
}

const PossibleRecipesLC = loadingContainer({
    'SUCCESS': PossibleRecipes
},{ type: 'padded' })

const getSubmitValues = (user,values) => (user.canEditOwnMacros() ? values : _.omit(values,['dailyNutritionProfiles']));

export const RecipePickWrapper = ({ t, children, recipeOptions }) => {
    const maxRecs = getMaxRecs(recipeOptions);

    return (
        <div className="text-center limit-50-h">
            <div className="ml5 mr5">
                <FlowQuestion className="mb0" text={maxRecs > 1 ? t("Pick 1-2 recipes for each meal") : t("pick recs to start")} />
                <div className="flow-question-subtitle">
                    {t("Your meal plan will be built around your choices")}
                    <IconTip icon='question-circle' msg={t("recipe pick tooltip")} size='1x' />
                </div>
            </div>
            
            {children}
        </div>
    )
}

const initRecPickHandler = (setValues,values) => ({ dailyNutritionProfiles, nutritionParameters }) => 
{
    const mnp = DailyNutritionProfile.pickForForm(_.find(Object.values(dailyNutritionProfiles),dnp => dnp.main));
    mnp.nutritionParameters = MacroParams.unfilteredBuildForForm(_.selectWithFKs(nutritionParameters,'dailyNutritionProfileId',[mnp.id]));
    setValues({ ...values, dailyNutritionProfiles: [{ ...mnp }] });
}

export const mealPlanQuotaModalSuffix = '/quota_hit';

export const MealPlanQuotaHitModal = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const path = modalPathFor(mealPlanQuotaModalSuffix,pathname);

    return (
        <SimpleContentModal 
            path={path}
            title={t("mp rate limit")}
            btnLabel={t("Ok")}
            render={() => {

                return (
                    <div className="pa20 text-center">
                        <SlightEmphasisIconNote text={t("meal plan quota hit")} />
                    </div>
                )
            }}
        />
    )
}

const InitialRecipePicker = ({ flowProps, loadInitialRecipeOptions, recipeOptions, getRecipeOptionsCatPage, setInitialRecipesFilter, startMealPlan, user, t, forNewWeek }) => {
    
    const { setValues, values } = flowProps;
    const submitValues = getSubmitValues(user,values);

    return (
        <RecipePickWrapper t={t} recipeOptions={recipeOptions}>
            <RedirectContext.Consumer>
                {disableRedirects => {
                    if(disableRedirects) {
                        return '';
                    }

                    return (
                        <LoadingContainerParent 
                            load={loadInitialRecipeOptions.bind(null,forNewWeek ? null : submitValues, initRecPickHandler(setValues,values))}
                            preloaded={() => false}
                            component={PossibleRecipesLC}
                            recipeOptions={recipeOptions}
                            getRecipeOptionsCatPage={getRecipeOptionsCatPage}
                            setInitialRecipesFilter={setInitialRecipesFilter}
                            flowProps={flowProps}
                            startMealPlan={startMealPlan}
                            user={user}
                            t={t}
                            forNewWeek={forNewWeek}
                        />
                    )
                }}
            </RedirectContext.Consumer>
            <MealPlanQuotaHitModal />
        </RecipePickWrapper>
    )
}

class StartDateQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.advanceTimeout = null;
    }

    advanceToRecipes = (values) => {
        this.props.resetInitialRecipeOptions();
        clearTimeout(this.advanceTimeout);
        this.advanceTimeout = setTimeout(() => this.props.flowProps.advance(values), 1);
    }

    render() {
        const { flowProps, t } = this.props;
        const { values, setFieldTouched, setFieldValue } = flowProps;
        const newAdvance = this.advanceToRecipes;

        return (
            <React.Fragment>
                <FlowQuestion text={t("Start meal plan each week on")} />
                <WeekdayButtonSelect 
                    startDay={0} 
                    name="mealPlanWeekday"
                    values={values} 
                    setFieldValue={autoAdvanceSetValue({ setFieldValue, values, advance: newAdvance })}
                    setFieldTouched={setFieldTouched}
                    dayNames={moment.weekdaysShort()}
                    single
                />
            </React.Fragment>
        );
    }
}


const CustomMacrosQuestion = ({ flowProps, recommendedCalories, user, t }) => {
    const { values: { dailyNutritionProfiles }, advance, validateForm, values, setTouched } = flowProps;
    const { nutritionParameters } = dailyNutritionProfiles[0];
    const fieldProps = _.pick(flowProps,formikInputProps);
    
    return (
        <React.Fragment>
            <div className="limit-50-h">
                <FlowQuestion text={t("Input your daily macros")} />
            </div>
            <div className="left-align-block limit-25-h ml10">
                <div>
                    <h3 className="inline-block green-title">{_.capitalize(t('calories'))}:</h3>
                    <InputWithErrors {...fieldProps} name="dailyNutritionProfiles.0.calorieOverride" component={NumberInput} className="inline" inProps={{ placeholder: recommendedCalories }} />
                </div>
                <div>
                    <h3 className="green-title mb0">{_.capitalize(t('macros'))}:</h3>
                    <UserMacroFields nutritionParameters={nutritionParameters} t={t} flowProps={flowProps} user={user} noRecCheck />
                </div>
                <div>
                    <h3 className="inline-block green-title">{_.capitalize(t('fiber g'))}:</h3>
                    <InputWithErrors {...fieldProps} inProps={{ placeholder: t('optional')}} name="dailyNutritionProfiles.0.fiberGoal" component={NumberInput} className="inline" />
                </div>
            </div>
            <NextButton 
                className="btn-wide mt65"
                label={t('Confirm')} 
                advance={advance} 
                validateForm={validateForm} 
                values={values} 
                isValid={true}
                setTouched={setTouched} 
                id='next-btn'
            />
        </React.Fragment>
    )
}

const skipMacroInputCreator = ({ advance, values, setValues }) => () => {
    const { dailyNutritionProfiles } = values;
    const { nutritionParameters } = dailyNutritionProfiles[0];
    const newParams = nutritionParameters.map(param => ({ ...param, _destroy: true}));
    const newValues = { ...values, dailyNutritionProfiles: [{ ...dailyNutritionProfiles[0], overrideCalories: false, calorieOverride: '', nutritionParameters: newParams }] };
    setValues(newValues);
    advance(newValues);
}

const MacroRecommendations = ({ recMacroParams, recommendedCalories, flowProps, t, user }) => {
    const { advance, values, setValues } = flowProps;

    return (
        <React.Fragment>
            <div className="primary-bar white-font mt40">
                <div className="centering">
                    <h4 className="mb0">
                        {recommendedCalories} {t('calories')}
                    </h4>
                    <div className="thin-text">
                        {recMacroParams.summary(t).map(msg => (
                            <div key={msg}>{msg}</div>
                        ))}
                    </div>
                </div>
            </div>
            {user.canEditOwnMacros() && (<div className="choose-goal-heading mt40 underline">
                <AutoAdvanceButton {...flowProps} attr="dailyNutritionProfiles.0.overrideCalories" value={true} render={({ onClick }) => (
                    <span className="buttonize-no-color" onClick={onClick} id="custom-macros-btn">{t('I want to put in my own calories/macros')}</span>
                )} />
            </div>)}
            <div className="mt95">
                <Button color="primary" rounded onClick={skipMacroInputCreator({ advance, values, setValues})} className="btn-wide" id="next-btn"><span>{t("Next")}</span></Button>
            </div>
        </React.Fragment>
    )
}

const MacroRecsLC = loadingContainer({
    'SUCCESS': MacroRecommendations
})

const MacroRecommendationsPage = ({ user, flowProps, initMacros, recMacroParams, recommendedCalories, t }) => {
    
    return (
        <div className="text-center limit-50-h ">
            <div className="ml5 mr5">
                <FlowQuestion text={user.isClient() ? t("coach macro rec msg") : t("macro recommendation message")} />
            </div>
            
            <LoadingContainerParent 
                load={initMacros.bind(null,getSubmitValues(user,flowProps.values))}
                preloaded={() => false}
                component={MacroRecsLC}
                recMacroParams={recMacroParams}
                recommendedCalories={recommendedCalories}
                flowProps={flowProps}
                user={user}
                t={t}
            />
        </div>
    )
}

const MealTypesQuestion = ({ flowProps, t }) => {
    const { isValid, values, advance, validateForm, setTouched, errors: { selectedMealTypes: error }, touched: { selectedMealTypes: touched } } = flowProps;
    const subtitleCnames = classnames("flow-question-subtitle",{"red-text": error && touched});

    return (
        <React.Fragment>
            <FlowQuestion text={t("Which meals do you want to include in your plan?")} />
            <div className={subtitleCnames}>{t("Pick at least",{count: 2})}</div>
            <div>
                <CheckButtons {...flowProps} name="selectedMealTypes" render={({ toggleHandler, values }) => {
                    return (
                        <React.Fragment>
                            {User.MEAL_TYPES.map(([mt,label]) => (
                                <SelectButton id={`select-${mt}-btn`} key={mt} toggleHandler={toggleHandler} value={mt} values={values}><span>{t(label)}</span></SelectButton>
                            ))}
                        </React.Fragment>
                    )
                }}/>
            </div>
            <NextButton 
                className="btn-wide mt65"
                label={t('Next')} 
                advance={advance} 
                validateForm={validateForm} 
                values={values} 
                isValid={isValid}
                setTouched={setTouched} 
                id='next-btn'
            />
        </React.Fragment>
    )
}

const ExclusionsQuestion = ({ flowProps,allergyTags, t }) => {
    const { values, advance, validateForm, setTouched } = flowProps;

    return (
        <React.Fragment>
            <FlowQuestion text={t('Do you have any food allergies?')} />
            <ExclusionTags allergyTags={allergyTags} {...flowProps} />
            <FlowQuestion text={t('Any keywords to exclude?')} tooltip={t("keyword exclusion tooltip")} />
            <ExtraExclusions t={t} values={flowProps.values} setFieldValue={flowProps.setFieldValue} />
            <NextButton 
                className="btn-wide mt25"
                label={t('Next')} 
                advance={advance} 
                validateForm={validateForm} 
                values={values} 
                isValid={true}
                setTouched={setTouched} 
                id='next-btn'
            />
        </React.Fragment>
    )
}

class BudgetVarietyComplexityQuestion extends React.Component {

    render() {
        const { flowProps,t } = this.props;
        const { setFieldValue, setFieldTouched, advance, validateForm, values, isValid, setTouched } = flowProps;
        const labelMap = [ 
            [t("What's your grocery budget?"), 'budget'],
            [t("What kind of weekly meal variety do you want?"), 'weeklyVariety',t('More repetitive'),t('More cooking')],
            [`${t("Max recipe complexity")}?`, 'complexityPreference',t('Basics only'),t('Complex')]
        ]
    
        return (
            <React.Fragment>
                {labelMap.map(([label, name, firstLabel, lastLabel]) => (
                    <React.Fragment key={name}>
                        <FlowQuestion text={label} />
                        <SmallButtonSelect  
                            name={name}
                            values={values}
                            options={User[`${name}Col`](t,false,false,true)}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            noWrap
                            minWidth
                            firstLabel={firstLabel}
                            lastLabel={lastLabel}
                            idBase={name}
                        />
                    </React.Fragment>
                ))}
                <NextButton 
                    className="btn-wide mt65"
                    label={t('Next')} 
                    advance={advance} 
                    validateForm={validateForm} 
                    values={values} 
                    isValid={isValid}
                    setTouched={setTouched} 
                    id='next-btn'
                />
            </React.Fragment>
        )
    }
}

const DietTypeQuestion = ({ flowProps, t}) => {

    const { advance, values, setTouched, validateForm, isValid } = flowProps;
    const allProps = _.pick(flowProps,[ 'values', 'touched', 'handleChange','setFieldValue', 'handleBlur']);

    return (
        <React.Fragment>
            <FlowQuestion text={t("What's your diet type?")} />
            <div className="radio-btn-container">
                {User.DIET_TYPES_FOR_FORM.map(([name,dietType]) => (
                    <RCButtonWithErrors key={dietType} id={`diet-type-${dietType}-radio`} name="dietType" label={t(name)} inProps={{ type: 'radio', value: dietType }} {...allProps} />
                ))}
            </div>
            <div>
                <NextButton 
                    className="btn-wide mt65"
                    label={t('Next')} 
                    advance={advance} 
                    validateForm={validateForm} 
                    values={values} 
                    isValid={isValid}
                    setTouched={setTouched} 
                    id='next-btn'
                />
            </div>
        </React.Fragment>
    )
}

class MealPlanSetupFlowPage extends Component {

    constructor(props) {
        super(props);
        props.setupTransitions(mealPlanSetupTransitionMap);
        this.state = { submitState: 'DEFAULT' }
    }

    setSubmitState = (status) => {
        this.setState({ submitState: status });
    }

    render() {
        const { 
            initialValues, 
            user, 
            allergyTags, 
            advanceAction, 
            submit, 
            initMacros, 
            finishSetup,
            loadInitialRecipeOptions,
            resetInitialRecipeOptions, 
            setInitialRecipesFilter,
            recipeOptions,
            getRecipeOptionsCatPage,
            startMealPlan,
            t,
            scrollRef,
            exitPath=homePath(),
            basePath=mealPlanSetupBase,
            progress=true,
            forNewWeek=false
        } = this.props;

        return (
        <Page ref={scrollRef} white>
            <FlowForm 
                initialValues={initialValues}
                validate={validateForm.bind(this,user,t)}
                validateOnMount={true}
                advanceCallback={advanceAction}
                onSubmit={formikHandlerCreator(this,this.setSubmitState,submit,valueFilter)}
                basePath={basePath}
                exitPath={exitPath}
                progress={progress}
                nextPage={getNextPage(user)}
            >
                    <FlowPageContent key='dietType' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer>
                                    <DietTypeQuestion flowProps={flowProps} t={t} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='budgetVarietyComplexity' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer>
                                    <BudgetVarietyComplexityQuestion flowProps={flowProps} t={t} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='exclusions' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer>
                                    <ExclusionsQuestion flowProps={flowProps} t={t} allergyTags={allergyTags} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='mealTypes' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer>
                                    <MealTypesQuestion flowProps={flowProps} t={t} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='recParams' render={(flowProps) => {
                            return (

                                    <MacroRecommendationsPage 
                                        flowProps={flowProps} 
                                        t={t} 
                                        recMacroParams={user.canEditOwnMacros() ? user.recMacroParams() : user.baseActiveMacroParams()} 
                                        recommendedCalories={user.canEditOwnMacros() ? user.recommendedCalsReadable() : user.baseTargetCalsReadable()} 
                                        initMacros={initMacros}
                                        user={user}
                                    />

                            )
                    }} />
                    <FlowPageContent key='macros' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer noLimitH>
                                    <CustomMacrosQuestion flowProps={flowProps} t={t} recommendedCalories={user.recommendedCalsReadable()} user={user} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='startDate' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer>
                                    <StartDateQuestion 
                                        flowProps={flowProps} 
                                        t={t} 
                                        resetInitialRecipeOptions={resetInitialRecipeOptions} 
                                    />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='pickRecipes' block render={(flowProps) => {
                            return (
                                <InitialRecipePicker 
                                    flowProps={flowProps} 
                                    t={t} 
                                    loadInitialRecipeOptions={loadInitialRecipeOptions} 
                                    recipeOptions={recipeOptions} 
                                    getRecipeOptionsCatPage={getRecipeOptionsCatPage}
                                    startMealPlan={startMealPlan}
                                    setInitialRecipesFilter={setInitialRecipesFilter}
                                    user={user}
                                    forNewWeek={forNewWeek}
                                />
                            )
                    }} />
                    <FlowPageContent key='finishSetup' block render={(flowProps) => {
                            return (
                                <FinishSetupLoader 
                                    flowProps={flowProps} 
                                    user={user}
                                    finishSetup={finishSetup}
                                />
                            )
                    }} />
            </FlowForm>
        </Page>
        );
    }

    componentWillUnmount() {
        if(this.loadPromise) {
            this.loadPromise.cancel();
        }
    }
}

const mapDispatchToMealPlanInitProps = dispatch => ({
    beforeAction: () => dispatch(clearInitialSignup()),
    afterPath: setupWeeklyPlanPath
})

export const MealPlanInit = connect(null,mapDispatchToMealPlanInitProps)(Connector)

let MealPlanSignup = ({ user, ...props }) => {
    if(user && user.hasBasicProfileFields()) {
        return (
            <MealPlanSetupFlowPage
                exitPath={null}
                user={user}
                basePath={mealPlanSignupBase}
                {...props}
            />
        )
    } else {
        return (<div><Redirect to={startPath} /></div>)
    }
    
}

export const MealPlanStandaloneContext = React.createContext(null)

let RecipePickClientSwitcher = (props) => {
    const { t } = useTranslation();
    const { trainer, scrollRef, setupTransitions, match: { params: { clientId, week } }, switchClient }  = props;
    const client = trainer.clientById(clientId);

    return (
        <PageWithTransitions
            ref={scrollRef} 
            white
            transitionMap={mealPlanSetupTransitionMap} 
            setupTransitions={setupTransitions} 
        >
            <FlowNav page={0} totalPages={1} progress={false} exitPath={null} />
            <FlowChooseGoal className="display-block">
                <RecipePickWrapper t={t}>
                    <HideOnExit>
                        <Loader
                            load={() => switchClient(clientId,client.switchMpFocusDate(week))}
                            preloaded={() => false}
                            successComponent={SwitchFinished}
                            afterPath={generateNewWeekPathFor(week,clientId)}
                            type='padded'
                        />
                    </HideOnExit>
                </RecipePickWrapper>
            </FlowChooseGoal>
        </PageWithTransitions>
    )
}

const mapStateToRPSwitchProps = state => ({
    trainer: trainerRecordSelector(state)
})

const mapDispatchToRPSwitchProps = dispatch => ({
    switchClient: (clientId,focusDate) => dispatch(switchClient(clientId,focusDate))
})

RecipePickClientSwitcher = connect(mapStateToRPSwitchProps,mapDispatchToRPSwitchProps)(RecipePickClientSwitcher);

let GenerateNewWeek = (props) => {
    let { showExitButton, match: { params: { week, clientId }}} = props;
    clientId = clientId !== 'main' ? clientId : null;
    return (
        <MealPlanStandaloneContext.Provider value={clientId}>
            <MealPlanSetupFlowPage
                exitPath={showExitButton ? resolvedHomePath() : null}
                basePath={generateNewWeekBaseFor(week,clientId)}
                forNewWeek={week}
                progress={false}
                {...props}
            />
        </MealPlanStandaloneContext.Provider>
    )
}

const mapStateToProps = (state) => ({
    initialValues: mealPlanFlowSelector(state),
    user: userRecordSelector(state),
    allergyTags: allergyTagsSelector(state),
    recommendedCalories: recommendedCalsSelector(state),
    recipeOptions: initialRecipeOptionsSelector(state),
    showExitButton: showMpExitButton(state)
})

const mapDispatchToProps = dispatch =>({
    advanceAction: (data) => dispatch(advanceMealPlanSetup(data)),
    initMacros: data => dispatch(initMacros(data)),
    finishSetup: data => dispatch(finishMealPlanSetup(data)),
    submit: data => data,
    resetInitialRecipeOptions: data => dispatch(resetInitialRecipeOptions(data)),
    loadInitialRecipeOptions: (data,success) => dispatch(loadInitialRecipeOptions(data,success)),
    getRecipeOptionsCatPage: (params,page) => dispatch(getRecipeOptionsCatPage({ page, ...params })),
    startMealPlan: (selectedRecipes,startDate,week) => dispatch(startMealPlan(selectedRecipes,startDate,week)),
    setInitialRecipesFilter: params => dispatch(setInitialRecipesFilter(params))
})

MealPlanSignup = connect(mapStateToProps,mapDispatchToProps)(withTranslation()(MealPlanSignup))
GenerateNewWeek = connect(mapStateToProps,mapDispatchToProps)(withTranslation()(GenerateNewWeek))

export { MealPlanSignup, RecipePickClientSwitcher, GenerateNewWeek }

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(MealPlanSetupFlowPage));
